<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-12">
          <app-create-user (userInfo)="userInfo($event)"></app-create-user>
          <label for="userId">Select User( if user is not in list create new by  above + button)</label>
          <span class="p-float-label required-field w-100 mb-3">
            <p-autoComplete class="col-lg-12" [suggestions]="users" [multiple]="false" [forceSelection]="false" [dropdown]="false" [style]="{'width':'100%'}"
              [inputStyle]="{'width':'100%'}" [minLength]="2" unique="true" field="fullName" placeholder="Select User" (completeMethod)="onKeyInput($event)"
            formControlName="userId" (onSelect)="onUserSeleted($event)"> </p-autoComplete>
            @for (validation of validationMessages.userId; track validation) {
              <span>
                @if (form1.get('userId').hasError(validation.type) && (form1.get('userId').dirty || form1.get('userId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>


        @if (updatedMailBoxes.length > 0 && (null != selectedUser)) {
          <p-table [columns]="columns" [value]="updatedMailBoxes" [tableStyle]="{'min-width': '50rem'}" >
            <ng-template pTemplate="header" let-columns>
              <tr>
                @for (col of columns; track col) {
                  <th>
                    {{col.header}}
                  </th>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
              <tr>
                <td>
                  <p-checkbox [value]="rowData" [(ngModel)]="rowData.hasAccess" [ngModelOptions]="{standalone: true}" [binary]="true" (onChange)="changePermission($event, rowData)"></p-checkbox>
                </td>
                <td>
                  {{rowData.name}}
                </td>
                <td>
                  {{rowData.email}}
                </td>
                <td>
                  {{rowData.host}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        }
      </div>
    </div>
  </div>
